module.exports = __webpack_public_path__ + "img/1-colorful.c011055f.png";